/* AFTER FOUR v60: optional carousel arrow controls, native video player remains user-controlled. */
(() => {
 const ready=(root=document)=>{
  root.querySelectorAll('[data-af60-reels]').forEach(section=>{
   if(section.dataset.af60Ready==='true')return;
   section.dataset.af60Ready='true';
   const rail=section.querySelector('[data-af60-rail]');
   if(!rail)return;
   section.querySelector('[data-af60-prev]')?.addEventListener('click',()=>move(-1));
   section.querySelector('[data-af60-next]')?.addEventListener('click',()=>move(1));
   function move(direction){
    const card=rail.querySelector('.af60-reels__card');
    if(!card)return;
    const gap=parseFloat(getComputedStyle(rail).gap)||12;
    rail.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   }
   rail.querySelectorAll('video').forEach(video=>{
    video.addEventListener('play',()=>{
     rail.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
    });
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>ready(),{once:true});
 else ready();
 document.addEventListener('shopify:section:load',event=>ready(event.target||document));
})();
